<template>
  <div class="no-access">
    <img class="icon" src="./img/hint.png" alt="" aria-hidden="true" />

    <h3 class="title">暂无使用权限</h3>

    <p class="desc">
      您可以点击上方免费领取
      <span class="highlight">{{ trialDays }}</span>
      天试用服务或直接购买正式服务
    </p>

    <div class="actions">
      <button
        type="button"
        class="btn btn-purchase"
        :disabled="showRealnameHint"
        @click="openPurchase"
      >
        购买服务
      </button>
      <button
        v-if="showRealnameHint"
        type="button"
        class="btn btn-realname"
        @click="openRealnameDialog"
      >
        去实名 &gt;
      </button>
    </div>

    <p
      v-if="showRealnameHint"
      class="tip"
      role="button"
      tabindex="0"
      @click="openRealnameDialog"
      @keydown.enter.prevent="openRealnameDialog"
    >
      购买正式服务前请先进行实名认证
    </p>

    <RealnameDialog
      :visible.sync="showRealnameDialog"
      @success="onRealnameSuccess"
    />
  </div>
</template>

<script>
import realnameDialogMixin from "../realname/realnameDialogMixin";
import {
  shouldShowRealnameHint,
} from "../realname/realnameService";
import { subscriptionState } from "./subscriptionService";

export default {
  name: "SubscriptionNoAccessPanel",

  mixins: [realnameDialogMixin],

  computed: {
    /** 可领取的试用天数 */
    trialDays() {
      return subscriptionState.trialDays || 14;
    },
    /** 是否展示「请先实名」提示 */
    showRealnameHint() {
      return shouldShowRealnameHint();
    },
  },

  methods: {
    /** 打开选套餐购买弹窗（未实名不可点击） */
    openPurchase() {
      if (this.showRealnameHint) return;
      this.$emit("purchase", subscriptionState.status);
    },
  },
};
</script>

<style scoped>
.no-access {
  box-sizing: border-box;
  min-height: 360px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0px 20px 40px;
  text-align: center;
}

.icon {
  display: block;
  width: 80px;
  height: 80px;
  margin-bottom: 40px;
  object-fit: contain;
}

.title {
  margin: 0 0 15px;
  font-size: 20px;
  font-weight: 600;
  color: #181e2d;
  line-height: 1.4;
}

.desc {
  margin: 0 0 40px;
  font-size: 16px;
  color: #424242;
  line-height: 1.6;
}

.highlight {
  margin: 0 2px;
  font-weight: 700;
  color: #f5222d;
}

.actions {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 12px;
}

.btn {
  min-width: 180px;
  height: 48px;
  padding: 0 24px;
  font-size: 16px;
  font-weight: 500;
  border: none;
  border-radius: 999px;
  cursor: pointer;
  outline: none;
}

.btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.btn-purchase {
  color: #4d2508;
  background: linear-gradient(-90deg, #ffe5b5 0%, #ffead1 100%);
  box-shadow: 0px 4px 8px 0px rgba(163, 120, 78, 0.2);
}

.btn-purchase:hover:not(:disabled) {
  background: #ffbc6d;
}

.btn-realname {
  color: #fff;
  background: #5b85ff;
}

.btn-realname:hover:not(:disabled) {
  opacity: 0.92;
}

.tip {
  padding-top: 10px;
  font-size: 14px;
  color: #F14545;
  line-height: 1.4;
  cursor: pointer;
  user-select: none;
}

.tip:hover {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/view/user/subscriptionService/SubscriptionNoAccessPanel.vue